var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLemonn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 998 1001",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M459 8.424c-70.16 9.326-135.15 24.889-198 58.885C97.426 155.785-5.627 340.299 7.09 526 18.744 696.188 115.354 848.987 266 930.374c34.62 18.704 71.835 32.961 110 42.499 11.641 2.91 28.562 9.588 40.577 8.194 3.131-.363-3.088-10.404-3.925-12.067-4.501-8.944-10.945-31.661-20.696-35.366-11.853-4.503-24.869-6.645-36.956-10.635-24.034-7.934-47.748-18.244-70-30.308C191.525 842.017 118.887 759.421 79.201 661-5.332 451.361 90.383 205.213 289 100.298c43.03-22.73 89.947-38.154 138-45.573 46.084-7.114 92.919-7.888 139-.16 48.26 8.093 95.778 22.368 139 45.744C765.25 132.894 818.253 177.648 858.845 233 967.681 381.411 974.398 589.33 872 743c-45.714 68.603-109.769 126.147-185 160.691-27.438 12.599-55.489 20.258-83.985 29.621-10.588 3.48-17.049 26.25-21.768 35.688-.751 1.501-6.582 11.001-4.431 11.958 5.636 2.506 21.256-3.476 27.184-4.839 26.138-6.01 52.233-13.413 77-23.836C786.641 907.825 877.763 829.645 930.742 727c36.456-70.633 56.339-148.501 57.254-228C989.918 331.961 898.227 167.946 756 80.811c-45.461-27.852-95.015-48.739-147-60.692-36.796-8.461-73.321-13.41-111-13.41-12.782 0-26.324.03-39 1.715Z",
    fill: "url(#a)",
    fillRule: "nonzero",
    transform: "translate(-1.04159 -5.75524) scale(1.00694)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M472 94.424c-24.653 3.237-48.636 5.663-73 11.152-8.202 1.848-22.134 3.857-26.005 12.464-2.941 6.538-.488 13.424.994 19.96 3.505 15.456 8.045 30.948 13.012 46 17.839 54.058 36.089 109.73 63.163 160 10.265 19.059 25.542 45.037 50.836 41.711 22.47-2.955 35.994-28.516 45.244-46.711 25.027-49.231 43.485-102.495 60.261-155 4.836-15.137 9.577-30.49 13.071-46 1.43-6.344 4.196-13.72.967-19.985-5.588-10.844-25.907-12.509-36.543-14.805-35.408-7.643-75.764-13.543-112-8.786Z",
    fill: "url(#b)",
    fillRule: "nonzero",
    transform: "translate(-1.04159 -5.75524) scale(1.00694)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M306 144.529c-14.83 3.398-29.848 16.099-42 24.762-37.032 26.4-70.17 58.947-95.67 96.709-7.482 11.08-14.91 22.232-21.301 34-2.754 5.07-6.153 12.105-4.372 18 2.05 6.789 9.635 10.783 15.343 14.139 13.746 8.081 27.911 15.257 42 22.694 44.697 23.596 92.129 44.859 140 61.17 20.559 7.005 45.065 16.237 67 10.518 28.432-7.413 21.326-41.653 16.231-62.521-5.307-21.737-14.933-42.544-23.807-63-15.166-34.963-31.097-69.394-49.129-103-7.608-14.177-15.269-28.466-23.987-42-4.958-7.696-10.345-13.753-20.308-11.471Z",
    fill: "url(#c)",
    fillRule: "nonzero",
    transform: "translate(-1.04159 -5.75524) scale(1.00694)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M678 144.858c-7.747 3.141-12.223 13.317-16.15 20.142-10.05 17.467-20.061 34.974-29.097 53-24.115 48.106-49.065 97.972-63.46 150-6.249 22.586-7.387 54.299 21.707 59.535 10.926 1.967 22.294-.594 33-2.63 11.462-2.179 23.098-6.219 34-10.33 50.708-19.124 101.555-40.398 149-66.714 12.145-6.736 40.704-16.015 44.323-30.861 3.2-13.132-14.829-34.985-21.899-45C801.26 232.104 768.847 197.364 729 168.86c-11.253-8.05-35.96-30.1-51-24.002Z",
    fill: "url(#d)",
    fillRule: "nonzero",
    transform: "translate(-1.04159 -5.75524) scale(1.00694)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M121.015 373.703c-5.633 1.956-8.525 8.118-10.551 13.297-5.091 13.012-7.442 28.255-9.71 42-7.798 47.26-8.948 98.016 1.596 145 2.945 13.124 3.891 35.375 14.755 44.697 7.708 6.613 19.415 1.824 27.895-.323 23.323-5.905 46.232-13.62 69-21.377 44.974-15.324 92.464-32.338 134-55.586 14.325-8.018 35.53-19.531 38.671-37.411 4.639-26.408-22.474-42.624-42.671-52.753-51.304-25.731-105.615-45.47-160-63.58-13.79-4.593-27.908-8.724-42-12.293-6.46-1.636-14.381-3.965-20.985-1.671Z",
    fill: "url(#e)",
    fillRule: "nonzero",
    transform: "translate(-1.04159 -5.75524) scale(1.00694)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M860 373.439c-19.337 3.044-38.413 10.625-57 16.532-46.724 14.851-92.187 33.355-137 53.169-21.105 9.331-54.131 23.77-59.482 48.86-5.687 26.664 28.157 44.091 47.482 53.753 49.863 24.931 103.708 45.401 157 61.661 16.695 5.093 41.356 17.429 58.999 14.257 17.623-3.169 19.782-39.729 22.39-53.671 9.285-49.64 6.978-100.512-1.639-150-3.198-18.366-6.172-48.43-30.75-44.561Z",
    fill: "url(#f)",
    fillRule: "nonzero",
    transform: "translate(-1.04159 -5.75524) scale(1.00694)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M382 567.428c-29.106 4.168-57.139 16.281-84 27.722-33.131 14.111-65.756 28.481-98 44.603-13.906 6.953-27.592 14.382-41 22.258-5.895 3.462-13.533 7.169-16.106 13.989-2.105 5.58.901 12.036 3.376 17 6.062 12.154 13.679 23.879 21.45 35 27.458 39.297 61.373 72.308 100.28 100.14 10.576 7.566 30.087 24.462 44 22.632 7.799-1.026 12.214-8.703 15.939-14.772 8.991-14.649 17.577-29.647 25.309-45 26.502-52.626 56.95-107.425 71.277-165 5.253-21.113 7.919-55.243-21.525-58.816-6.623-.803-14.403-.7-21 .244Z",
    fill: "url(#g)",
    fillRule: "nonzero",
    transform: "translate(-1.04159 -5.75524) scale(1.00694)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M589 567.515c-29.449 6.074-24.746 40.68-18.849 62.485 15.404 56.958 44.191 114.552 72.71 166 8.009 14.448 15.826 29.026 24.66 43 4.345 6.874 9.515 13.175 18.479 11.532 15.933-2.922 33.29-17.416 46-26.906 35.887-26.798 68.972-58.129 93.924-95.626 7.514-11.292 15.469-22.815 21.471-35 2.421-4.916 5.464-11.494 3.442-17-2.511-6.839-9.986-10.31-15.837-13.799-13.372-7.976-27.238-15.158-41-22.42-41.593-21.947-85.281-39.808-129-56.984-22.504-8.841-51.354-20.366-76-15.282Z",
    fill: "url(#h)",
    fillRule: "nonzero",
    transform: "translate(-1.04159 -5.75524) scale(1.00694)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M442 446.518c-33.104 7.062-15.583 57.091-1.841 75.467 17.485 23.381 57.85 23.808 83.841 17.78 28.644-6.644 37.251-29.136 44.151-54.765 2.931-10.886 6.172-25.122-4.244-33.211C554.24 444.283 541.428 446 530 446h-58c-9.589 0-20.601-1.487-30 .518Z",
    fill: "url(#i)",
    fillRule: "nonzero",
    transform: "translate(-1.04159 -5.75524) scale(1.00694)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M466 575.703c-8.394 2.844-12.354 12.471-14.572 20.297-5.592 19.731-7.715 40.771-10.852 61-7.788 50.216-14.199 100.384-17.666 151-2.565 37.467-3.432 71.36 13.843 106 11.622 23.303 21.988 48.989 37.533 70 5.893 7.964 15.576 18.5 26.714 15.199 9.932-2.943 16.572-11.997 21.996-20.199 12.022-18.178 20.4-38.721 30.453-58 19.279-36.97 20.42-71.417 17.64-112-3.034-44.317-10.177-87.831-14.923-132-2.195-20.426-6.182-40.738-9.58-61-1.85-11.033-3.48-24.759-10.375-33.96-9.61-12.824-38.814-7.04-53.211-7.04-5.316 0-11.906-1.023-17 .703Z",
    fill: "url(#j)",
    fillRule: "nonzero",
    transform: "translate(-1.04159 -5.75524) scale(1.00694)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(801 -755 755 801 98 865)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffee4f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(801 -755 755 801 98 865)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffee4f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(801 -755 755 801 98 865)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffee4f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(801 -755 755 801 98 865)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffee4f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(801 -755 755 801 98 865)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffee4f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(801 -755 755 801 98 865)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffee4f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(801 -755 755 801 98 865)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffee4f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(801 -755 755 801 98 865)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffee4f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(90 63.374 508.843) scale(554.351)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8c42f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d27b5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(90 63.374 508.843) scale(554.351)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8c42f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4d27b5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLemonn);
export default __webpack_public_path__ + "static/media/lemonn.407783d6.svg";
export { ForwardRef as ReactComponent };